export const DEFAULT_PERMISSIONS = {
  canAdd: false,
  canEdit: false,
  canView: false,
  canDelete: false
};

// The user type allowed to sign off an FSR. The backend's authoritative gate is
// the `approve` flag in FSR Configurations; this additionally narrows the button
// to the designated engineer, per spec. Must match a UserType.name row exactly.
export const FSR_APPROVER_USER_TYPE = 'Engineer';

// Drill-down pages that have no side-menu entry of their own — they are
// reached from a list page, so they borrow that entry's sidebar highlight
// and its permissions instead of falling back to "no access".
export const DETAIL_ROUTE_OWNERS: ReadonlyArray<{ prefix: string; owner: string }> = [
  { prefix: '/plant-management/plant-detail', owner: '/plant-management/plants' },
  { prefix: '/plant-management/cluster', owner: '/plant-management/plants' }
];

// Strips the query string and maps a drill-down route onto the menu entry it
// belongs to, so menu lookups (highlighting, permissions) see a URL that
// actually exists in the menu.
export function resolveMenuUrl(url: string): string {
  const path = (url || '').split('?')[0];
  const owner = DETAIL_ROUTE_OWNERS.find(
    (entry) => path === entry.prefix || path.startsWith(entry.prefix + '/')
  );
  return owner ? owner.owner : path;
}
